import { useState, useRef, useCallback } from 'react';

const GAME_EMOJIS = ['😂', '🔥', '💀', '👑', '😤', '🎉'];
const COOLDOWN_MS = 2000; // 2 seconds between emojis

export const GameEmojiBar = ({ onSendEmoji }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [cooldown, setCooldown] = useState(false);
  const cooldownRef = useRef(false);

  const handleEmoji = useCallback((emoji) => {
    if (cooldownRef.current) return;
    cooldownRef.current = true;
    setCooldown(true);
    onSendEmoji(emoji);
    setIsOpen(false);
    setTimeout(() => {
      cooldownRef.current = false;
      setCooldown(false);
    }, COOLDOWN_MS);
  }, [onSendEmoji]);

  if (!isOpen) {
    return (
      <button
        onClick={(e) => { e.stopPropagation(); setIsOpen(true); }}
        className={`absolute bottom-4 right-4 z-[45] w-11 h-11 rounded-full flex items-center justify-center transition-all ${
          cooldown ? 'opacity-40 cursor-not-allowed' : 'hover:scale-110 active:scale-95'
        }`}
        style={{
          background: 'rgba(0,0,0,0.5)',
          backdropFilter: 'blur(8px)',
          border: '1px solid rgba(255,255,255,0.15)',
        }}
        disabled={cooldown}
        data-testid="emoji-bar-toggle"
      >
        <span className="text-lg">😀</span>
      </button>
    );
  }

  return (
    <div
      className="absolute bottom-4 right-4 z-[45] flex items-center gap-1 px-2 py-1.5 rounded-2xl"
      style={{
        background: 'rgba(0,0,0,0.7)',
        backdropFilter: 'blur(12px)',
        border: '1px solid rgba(255,255,255,0.15)',
      }}
      onClick={(e) => e.stopPropagation()}
      data-testid="emoji-bar-panel"
    >
      {GAME_EMOJIS.map((emoji) => (
        <button
          key={emoji}
          onClick={() => handleEmoji(emoji)}
          className="text-xl hover:scale-130 active:scale-90 transition-transform p-1"
          data-testid={`emoji-btn-${emoji}`}
        >
          {emoji}
        </button>
      ))}
      <button
        onClick={() => setIsOpen(false)}
        className="text-white/40 hover:text-white/80 text-xs ml-1 p-1"
      >
        ✕
      </button>
    </div>
  );
};

// Floating emoji that appears over a player's character position
export const GameFloatingEmoji = ({ emoji, x, y }) => {
  return (
    <div
      className="absolute pointer-events-none z-[46] text-3xl"
      style={{
        left: x,
        top: y,
        animation: 'gameEmojiFloat 1.5s ease-out forwards',
      }}
    >
      {emoji}
      <style>{`
        @keyframes gameEmojiFloat {
          0% { opacity: 1; transform: scale(0.3) translateY(0); }
          20% { opacity: 1; transform: scale(1.4) translateY(-10px); }
          50% { opacity: 1; transform: scale(1.0) translateY(-30px); }
          100% { opacity: 0; transform: scale(0.6) translateY(-60px); }
        }
      `}</style>
    </div>
  );
};
